import React, { useEffect, useState, createContext, useContext } from "react";
import axios from "axios";
import { UserSchema } from "schema/account";
import { useConnection } from "./ConnectionProvider";

export const AuthContext = createContext(null); // AuthProvider component to manage authentication state

export const AuthProvider = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [user, setUser] = useState(null);
    const { hasConnection, isCheckingConnection } = useConnection();

    useEffect(() => {
        const checkAuthStatus = async () => {
            try {
                const response = await axios.get("account/simple_profile");
                if (response.status === 200) {
                    const profile = await UserSchema.validate(response.data);
                    setUser(profile);
                    setIsAuthenticated(true);
                } else {
                    setUser(null);
                    setIsAuthenticated(false);
                }
            } catch (error) {
                console.error("Error checking authentication:", error);
                setIsAuthenticated(false);
            } finally {
                setIsLoading(false);
            }
        };

        // Only check auth if connection check is done
        if (!isCheckingConnection) {
            if (hasConnection) {
                checkAuthStatus();
            } else {
                setIsLoading(false);
            }
        }
    }, [hasConnection, isCheckingConnection]);
    const logout = async () => {
        setIsLoading(true);
        await axios
            .post("account/logout")
            .then(() => {
                setUser(null);
                setIsAuthenticated(false);
            })
            .catch((error) => {
                console.error(error);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };
    return (
        <AuthContext.Provider
            value={{ isAuthenticated, isLoading, logout, user, hasConnection }}
        >
            {children}
        </AuthContext.Provider>
    );
};

// Custom hook to use authentication context
export const useAuth = () => {
    return useContext(AuthContext);
};
